import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/search-redesign.svg'


const _hoisted_1 = { class: "w-full h-[calc(100vh-52px)] overflow-y-auto flex" }
const _hoisted_2 = {
  key: 0,
  class: "w-[190px] mt-10 flex flex-col items-center gap-3"
}
const _hoisted_3 = {
  key: 1,
  class: "min-w-[190px] w-[190px]"
}
const _hoisted_4 = { class: "w-full h-full flex flex-col" }
const _hoisted_5 = { class: "max-w-[996px] p-[31px] mx-auto flex flex-col h-full" }
const _hoisted_6 = { class: "flex items-center gap-2 mb-[19px] w-[996px]" }
const _hoisted_7 = { class: "text-xl leading-8 font-semibold text-primary-text-color tracking-[0.01rem]" }
const _hoisted_8 = ["placeholder"]

import InstallersTable from "@/components/installer/InstallersTable.vue";
import InlineLoader from "@/components/Loaders/InlineLoader.vue";
import SecondaryPageHeader from "@/components/PageHeader/SecondaryPageHeader.vue";
import InstallersSidemenu from "@/components/Sidebar/installer/InstallersSidemenu.vue";
import { useTranslate } from "@/composables/useTranslate";
import MainLayout from "@/layouts/MainLayout.vue";
import { Worker } from "@/types";
import client from "@/utils/axios";
import { computed, onMounted, ref } from "vue";

// Refs

export default /*@__PURE__*/_defineComponent({
  __name: 'InstallersView',
  setup(__props) {

const workers = ref<Worker[]>([]);
const searchInput = ref<string>("");
const selectedMonths = ref<Record<string, string>>({});
const isLoading = ref<boolean>(false);
const isSearchFocused = ref<boolean>(false);
const { t } = useTranslate();

// Functions
const getAllInstallers = async () => {
  isLoading.value = true;
  try {
    const response = await client.get("/installers");
    workers.value = response.data;
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

const handleSelectMonth = (workerId: string, month: string) => {
  selectedMonths.value[workerId] = month;
};

// Computed properties
const filteredWorkers = computed(() => {
  return workers.value.filter((item: Worker) => {
    let searchQuery = searchInput.value
      ? searchInput.value.trim().toLowerCase()
      : "";
    return item.fullname.toLowerCase().includes(searchQuery);
  });
});

// Lifecycle hooks
onMounted(() => {
  getAllInstallers();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MainLayout, null, {
    default: _withCtx(() => [
      _createVNode(SecondaryPageHeader, { "is-installers": true }),
      _createElementVNode("div", _hoisted_1, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(InlineLoader),
              _createVNode(InlineLoader),
              _createVNode(InlineLoader),
              _createVNode(InlineLoader)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(InstallersSidemenu, {
                workers: workers.value,
                "selected-months": selectedMonths.value,
                onSelectMonth: handleSelectMonth
              }, null, 8, ["workers", "selected-months"])
            ])),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h2", _hoisted_7, _toDisplayString(_unref(t)("installers.all_installers")), 1),
              _createElementVNode("form", {
                class: _normalizeClass(["w-[302px] h-[30px] px-[10px] flex items-center gap-[6px] bg-transparent border border-[#A7A5AE] rounded-primary-radius", `${isSearchFocused.value ? 'bg-white' : ''}`])
              }, [
                _cache[3] || (_cache[3] = _createElementVNode("img", {
                  class: "w-4 h-4",
                  src: _imports_0,
                  alt: "Search"
                }, null, -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchInput).value = $event)),
                  class: "w-full outline-none bg-transparent text-sm font-normal leading-5 text-[#898790] placeholder:text-[#898790]",
                  type: "text",
                  placeholder: 
                  isSearchFocused.value
                    ? _unref(t)('installers.installer_name').value
                    : _unref(t)('home.search').value
                ,
                  onFocus: _cache[1] || (_cache[1] = ($event: any) => (isSearchFocused.value = true)),
                  onBlur: _cache[2] || (_cache[2] = ($event: any) => (isSearchFocused.value = false))
                }, null, 40, _hoisted_8), [
                  [_vModelText, searchInput.value]
                ])
              ], 2)
            ]),
            (filteredWorkers.value)
              ? (_openBlock(), _createBlock(InstallersTable, {
                  key: 0,
                  workers: filteredWorkers.value
                }, null, 8, ["workers"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})